import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
type Bono = {
  badge: string;
  title: string;
  desc: string;
  includes: string[];
  oldValue: string;
};
const bonos: Bono[] = [{
  badge: '🎁Bono 01',
  title: 'RESPUESTAS RÁPIDAS PARA PADRES AGOTADOS',
  desc: 'La versión express del sistema. Cuando son las 3AM y no puedes pensar, abres esto y encuentras la respuesta en 60 segundos. Sin buscar. Sin leer. Solo actuar.',
  includes: ['Mapa rápido de revisión del bebé', 'Respuestas por problema en menos de 1 minuto', 'Checklist de acción inmediata para noches difíciles'],
  oldValue: '19,97€'
}, {
  badge: '🎁Bono 02',
  title: 'ORGANIZADOR SEMANAL DE CRIANZA',
  desc: 'Un planner diseñado para padres primerizos reales. Organiza sueño, comidas, tareas y avances en un solo lugar. Menos caos mental. Más calma diaria.',
  includes: ['Plantilla semanal completa', 'Tracker de sueño y alimentación', 'Reparto de tareas sin conflictos'],
  oldValue: '14,97€'
}, {
  badge: '🎁Bono 03',
  title: 'GUÍA DE CALMA PARA PADRES PRIMERIZOS',
  desc: 'Para los días en los que sientes que no puedes más. Herramientas reales para bajar el desborde emocional, recuperar regulación y seguir adelante con claridad.',
  includes: ['Protocolo de pausa de 5 minutos', 'Plan para días especialmente difíciles', 'Mini herramientas de calma en 1 minuto'],
  oldValue: '12,97€'
}];
export function BonosSection() {
  return <section className="bg-white py-[72px] px-5" data-id="element-13">
      <div className="max-w-[1000px] mx-auto" data-id="element-14">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center" data-id="element-15">
          <span className="text-[0.75rem] tracking-[0.18em] uppercase text-navy mb-3 block" data-id="element-16">
            🎁Incluido con tu compra🎁
          </span>
          <h2 className="font-serif text-navy mb-5 text-[clamp(1.6rem,3.5vw,2.4rem)]" data-id="element-17">
            3 Bonos que convierten el sistema en{' '}
            <em className="not-italic text-gold-dark" data-id="element-18">
              algo que usas cada día
            </em>
          </h2>
          <div className="w-12 h-[3px] bg-gold mx-auto mb-8" data-id="element-19" />
          <p className="max-w-[580px] mx-auto mb-4 text-[#666]" data-id="element-20">
            No son relleno. Cada bono resuelve un ángulo diferente que los tomos
            no cubren en formato rápido.
          </p>
        </motion.div>

        <div className="grid gap-5 mt-10 grid-cols-1 md:grid-cols-3" data-id="element-21">
          {bonos.map((b, i) => <motion.div key={b.badge} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="relative bg-[#f8f9fc] rounded-[10px] p-[26px] border border-[#e8ecf4]" data-id="element-22">
              <span className="absolute -top-3 left-5 bg-navy-light text-gold text-[0.7rem] tracking-[0.12em] uppercase py-1 px-3 rounded-full" data-id="element-23">
                {b.badge}
              </span>
              <h3 className="font-serif text-base text-navy mt-6 mb-2.5" data-id="element-24">
                {b.title}
              </h3>
              <p className="text-[0.88rem] text-[#666] mb-3.5" data-id="element-25">{b.desc}</p>
              <ul className="list-none mb-3.5" data-id="element-26">
                {b.includes.map(line => <li key={line} className="text-[0.85rem] text-[#444] py-1 pl-5 relative" data-id="element-27">
                    <CheckIcon className="absolute left-0 top-1.5 w-3.5 h-3.5 text-[#2a7a4f]" data-id="element-28" />
                    {line}
                  </li>)}
              </ul>
              <div className="text-[0.82rem] text-[#999]" data-id="element-29">
                Valor: <span className="line-through" data-id="element-30">{b.oldValue}</span>{' '}
                <strong className="text-[#2a7a4f] ml-1.5" data-id="element-31">GRATIS</strong>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}